import motion from '@lib/motion';

class CategoriesGrid extends HTMLDivElement {
  constructor() {
    super();
    this.section = this.closest('.shopify-section');
    this.duration = 0.35;
    this.hoverAnimation = this.dataset.cardHoverAnimation;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (this.hoverAnimation === 'normal-blur' || this.hoverAnimation === 'none') return;
    const wrappers = this.querySelectorAll('[data-category-media-wrapper]');

    wrappers.forEach((wrapper) => {
      const item = wrapper.closest('[data-category-item]');
      if (!item) return;

      const bottomImage = wrapper.querySelector('[data-category-image]:first-child');
      const topImage = wrapper.querySelector('[data-category-image]:last-child');
      if (!bottomImage || !topImage) return;

      // Reset elements to default CSS states to be clean
      bottomImage.style.transform = '';
      bottomImage.style.filter = '';
      topImage.style.clipPath = '';
      topImage.style.filter = '';

      // If normal-blur is selected, we don't bind hover events in JS (handled via CSS)
      if (this.hoverAnimation === 'normal-blur' || this.hoverAnimation === 'none') return;

      let activeTopAnim = null;
      let activeBottomAnim = null;

      const handleMouseEnter = () => {
        if (activeTopAnim) activeTopAnim.stop();
        if (activeBottomAnim) activeBottomAnim.stop();

        if (this.hoverAnimation === 'clip-with-brightness') {
          activeTopAnim = motion.animate(
            topImage,
            {
              clipPath: [
                'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
                'polygon(100% 0%, 100% 0%, 0% 100%, 0% 100%)',
              ],
            },
            {
              duration: this.duration,
              easing: [0.16, 1, 0.3, 1],
            }
          );

          activeBottomAnim = motion.animate(
            bottomImage,
            {
              transform: ['skewX(15deg) scale(2)', 'skewX(0deg) scale(1.1)'],
              filter: ['brightness(600%)', 'brightness(100%)'],
            },
            {
              duration: this.duration,
              easing: [0.16, 1, 0.3, 1],
            }
          );
        } else if (this.hoverAnimation === 'clip-with-blur') {
          activeTopAnim = motion.animate(
            topImage,
            {
              clipPath: [
                'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
                'polygon(100% 0%, 100% 0%, 0% 100%, 0% 100%)',
              ],
            },
            {
              duration: this.duration,
              easing: [0.16, 1, 0.3, 1],
            }
          );

          activeBottomAnim = motion.animate(
            bottomImage,
            {
              transform: ['skewX(15deg) scale(2)', 'skewX(0deg) scale(1.1)'],
              filter: ['blur(0px) brightness(0%)', 'blur(2px) brightness(100%)'],
            },
            {
              duration: this.duration,
              easing: [0.16, 1, 0.3, 1],
            }
          );
        }
      };

      const handleMouseLeave = () => {
        if (activeTopAnim) activeTopAnim.stop();
        if (activeBottomAnim) activeBottomAnim.stop();

        if (this.hoverAnimation === 'clip-with-brightness') {
          activeTopAnim = motion.animate(
            topImage,
            {
              clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
            },
            {
              duration: this.duration,
              easing: [0.16, 1, 0.3, 1],
            }
          );

          activeBottomAnim = motion.animate(
            bottomImage,
            {
              transform: 'skewX(15deg) scale(2)',
              filter: 'brightness(600%)',
            },
            {
              duration: this.duration,
              easing: [0.16, 1, 0.3, 1],
            }
          );

          activeBottomAnim.finished
            .then(() => {
              if (bottomImage.style.filter.includes('600%') || bottomImage.style.filter === 'brightness(600%)') {
                bottomImage.style.filter = 'brightness(0%)';
              }
            })
            .catch(() => { });
        } else if (this.hoverAnimation === 'clip-with-blur') {
          activeTopAnim = motion.animate(
            topImage,
            {
              clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
            },
            {
              duration: this.duration,
              easing: [0.16, 1, 0.3, 1],
            }
          );

          activeBottomAnim = motion.animate(
            bottomImage,
            {
              transform: 'skewX(15deg) scale(2)',
              filter: 'blur(0px) brightness(0%)',
            },
            {
              duration: this.duration,
              easing: [0.16, 1, 0.3, 1],
            }
          );
        }
      };

      // Bind events to the item
      item.addEventListener('mouseenter', handleMouseEnter);
      item.addEventListener('mouseleave', handleMouseLeave);

      // Save bound handlers for cleanup
      item._handleMouseEnter = handleMouseEnter;
      item._handleMouseLeave = handleMouseLeave;
    });
  }

  disconnectedCallback() {
    const wrappers = this.querySelectorAll('[data-category-media-wrapper]');
    wrappers.forEach((wrapper) => {
      const item = wrapper.closest('[data-category-item]');
      if (item && item._handleMouseEnter && item._handleMouseLeave) {
        item.removeEventListener('mouseenter', item._handleMouseEnter);
        item.removeEventListener('mouseleave', item._handleMouseLeave);
      }
    });
  }
}

if (!customElements.get('categories-grid')) {
  customElements.define('categories-grid', CategoriesGrid, { extends: 'div' });
}